<div class="collapsible-section">
  <app-card>
    <details class="collapsible-section__details" [open]="isOpen" (toggle)="onToggle($event)">
      <summary class="collapsible-section__summary">
        <h3 class="collapsible-section__title">
          {{ title }}
          <span class="collapsible-section__count" *ngIf="count !== null && count !== undefined && count > 0">
            ({{ count }})
          </span>
          <span class="collapsible-section__chevron-hitbox" aria-hidden="true">
            <i class="fas fa-chevron-down collapsible-section__chevron"></i>
          </span>
        </h3>
      </summary>
      <div class="collapsible-section__content">
        <ng-content></ng-content>
      </div>
    </details>
  </app-card>
</div>
